import useTranslation from "@babackapp/translations/use-translation";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@babackapp/ui/components/card";
import { RefreshCw } from "lucide-react";
import { useCallback, useState } from "react";
import { ShippingMethods } from "./form/shipping-methods-form";
import { useCarriersContext } from "./use-carriers-context";

export const ShippingMethodsCard = () => {
  const t = useTranslation();
  const { shop, refreshShippingMethods } = useCarriersContext();
  const [loadingShippingMethods, setLoadingShippingMethods] = useState(false);
  const onRefreshShippingMethods = useCallback(() => {
    setLoadingShippingMethods(true);
    refreshShippingMethods();
  }, []);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("settings.config.myShippingMethod")}</CardTitle>

        <CardDescription>
          <div className="self-center text-gray-700 flex">
            <div>
              {t("settings.config.shippingMethod", {
                count: shop.exchange.shippingMethods.length,
              })}
            </div>
            <div
              className="flex items-center ml-2 text-gray-500 hover:text-gray-900 cursor-pointer "
              onClick={onRefreshShippingMethods}
            >
              <div
                className={`mr-0.5 ${
                  loadingShippingMethods ? "animate-spin" : ""
                }`}
              >
                <RefreshCw className="h-4 w-4 -scale-y-100" />
              </div>
              <div>{t("misc.refresh")}</div>
            </div>
          </div>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ShippingMethods />
      </CardContent>
    </Card>
  );
};
